export default {

    albumInfo : function (id) {
        return {
            url: 'portal/api/audio/album',
            data: {
                id: id
            }
        }
    }

};
